import {scopeGapi} from '@/constants/googleApi/scopeGapi'
import {GoogleToken} from 'gtoken'

export default {
  computed: {
    configApiKeys () {
      return this.$store.getters.configApiKeys
    },
    serverAccountKey () {
      return this.configApiKeys.serverAccountKey
    }
  },
  methods: {
    authServiceAccount (userId, callback) {
      const gtoken = new GoogleToken({
        key: this.serverAccountKey.private_key,
        iss: this.serverAccountKey.client_email,
        sub: userId,
        scope: scopeGapi.split(' ')
      })
      gtoken.getToken(callback)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/authServiceAccount.js